// extracted by mini-css-extract-plugin
module.exports = {"main_wrapper":"main-layout_main_wrapper__EDe20","main":"main-layout_main__0sKFa","container":"main-layout_container__S5hsX"};